import React from 'react';

import { useWindow } from 'app/hooks/useWindow.hook';
import { SIZE } from 'app/utils/sizes';
import { usePostHog } from 'posthog-js/react';

import 'app/components/Defacto/Defacto.scss';

export default function Defacto() {
  const { width } = useWindow();
  const posthog = usePostHog();

  const mobile = width < SIZE.LG;

  return (
    <a
      href="https://www.getdefacto.com/platform/inventory-financing?utm_source=bigbuygroup&utm_medium=bannercontrolpanel&utm_campaign=defacto_lanzamiento"
      target="_blank"
      rel="noopener noreferrer"
      className="bb-defacto"
      onClick={() => {
        posthog.capture('banner_defacto_clicked');
      }}
    >
      {mobile ? (
        <img
          src="https://cms.bigbuy.eu/uploads/panel_de_control_mobile_a1d5b25739.png"
          alt="Defacto"
          className="bb-defacto__image__mobile"
        />
      ) : (
        <img
          src="https://cms.bigbuy.eu/uploads/Frame_37929_52103adcd9.png"
          alt="Defacto"
          className="bb-defacto__image__desktop"
        />
      )}
    </a>
  );
}
